import { ParameterGroups } from '../parameterGroups/ParameterGroups';
import { useComponent, useComponentUpdate } from './componentUtils';

export const ComponentParameterGroups = ({ stackComponentID }: { stackComponentID: number }) => {
  const component = useComponent(stackComponentID);

  const handleChange = useComponentUpdate(
    stackComponentID,
    (componentState) => (groupIdentifier: string, parameterIdentifier: string, value?: string | number | boolean | null) => {
      const parameterGroup = componentState.parameterGroups.find((parameterGroup) => parameterGroup.identifier === groupIdentifier);
      if (!parameterGroup) return;

      const parameter = parameterGroup.parameters.find((parameter) => parameter.identifier === parameterIdentifier);
      if (!parameter) return;

      parameter.value = value || '';
    }
  );

  const handleToggle = useComponentUpdate(stackComponentID, (componentState) => (groupIdentifier: string, value: boolean) => {
    const parameterGroup = componentState.parameterGroups.find((parameterGroup) => parameterGroup.identifier === groupIdentifier);
    if (!parameterGroup) return;

    parameterGroup.enabled = value;
  });

  if (!component?.config) return null;
  if (!component.parameterGroups.length) return null;

  return (
    <ParameterGroups
      parameterGroups={component.config.parameterGroups}
      values={component.parameterGroups}
      onToggle={handleToggle}
      onChange={handleChange}
    />
  );
};
